import { Form } from 'react-bootstrap';
import React from 'react';

interface BadgeMultiSelectProps<T> {
  label: string;
  allItems: T[];
  selectedItems: T[];
  onToggle: (item: T) => void;
  getId: (item: T) => number;
  getLabel: (item: T) => string;
  dropDownClassName?: string;
  badgeClassName?: string;
  selectAllItems?: () => void;
}

function BadgeMultiSelect<T>({
  label,
  allItems,
  selectedItems,
  onToggle,
  getId,
  getLabel,
  dropDownClassName,
  badgeClassName,
  selectAllItems,
}: BadgeMultiSelectProps<T>) {
  const unselectedItems = allItems.filter(
    (item) => !selectedItems.some((s) => getId(s) === getId(item))
  );

  const sortedSelected = [...selectedItems].sort((a, b) =>
    getLabel(a).localeCompare(getLabel(b))
  );

  function handleSelectChange(e: React.ChangeEvent<HTMLSelectElement>) {
    const selectedId = e.target.value;
    if (selectedId === '__select_all__') {
      if (selectAllItems) selectAllItems();
      return;
    }

    const parsedId = parseInt(selectedId);
    const selectedItem = allItems.find((item) => getId(item) === parsedId);
    if (selectedItem) {
      onToggle(selectedItem);
    }
  }

  return (
    <Form.Group className="mb-3">
      <Form.Label>{label}</Form.Label>
      <Form.Select
        className={dropDownClassName}
        onChange={handleSelectChange}
        value=""
      >
        <option value="" disabled>
          Select...
        </option>
        {selectAllItems && <option value="__select_all__">Select All</option>}
        {unselectedItems.map((item) => (
          <option key={getId(item)} value={getId(item)}>
            {getLabel(item)}
          </option>
        ))}
      </Form.Select>

      <div className="mt-2 d-flex flex-wrap gap-2">
        {sortedSelected.map((item) => (
          <span
            key={getId(item)}
            className={`badge rounded-pill ${badgeClassName || 'bg-dark'}`}
          >
            <strong>{getLabel(item)}</strong>
            <button
              type="button"
              className="btn-close btn-close-white ms-2"
              aria-label="Remove"
              onClick={() => onToggle(item)}
            ></button>
          </span>
        ))}
      </div>
    </Form.Group>
  );
}

export default BadgeMultiSelect;
